import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { getImpactCalculateTourForProject } from './actions/get-impact-calculate-tour-for-project.action';
import { CalculateTour } from './entities/calculate-tour.entity';

export type ImpactCalculateTourState = {
  isFetching: boolean;
  byProjectId: {
    [projectId: number]: CalculateTour;
  };
};

const initialState: ImpactCalculateTourState = {
  isFetching: false,
  byProjectId: {},
};

export const impactCalculateTourSlice = createSlice({
  name: 'impactCalculateTour',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // getImpactCalculateTourForProject
      .addCase(getImpactCalculateTourForProject.fulfilled, (state, action) => {
        const projectId: number = action.meta.arg.projectId;
        state.byProjectId[projectId] = {
          ...state.byProjectId[projectId],
          ...action.payload,
        };
      })
      // isFetching
      .addMatcher(
        isAnyOf(getImpactCalculateTourForProject.pending),
        (state) => {
          state.isFetching = true;
        },
      );
  },
});
